(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-brands"] && !Shopify.designMode) return;
  try {
    
(function() {
  const sections = document.querySelectorAll('.featured-brands-section');
  if (!sections.length) return;

  sections.forEach((section) => {
    const grid = section.querySelector('[data-brands-grid]');
    if (!grid) return;

    const toggleBtn = section.querySelector('[data-brands-toggle]');
    if (!toggleBtn) return;

    const mobileInitial = parseInt(grid.getAttribute('data-mobile-initial'), 10) || 0;
    const items = grid.querySelectorAll('[data-brand-item]');
    const toggleText = toggleBtn.querySelector('[data-toggle-text]');

    let isExpanded = false;

    function updateVisibility() {
      if (window.innerWidth >= 768) {
        items.forEach((item) => {
          item.removeAttribute('data-hidden');
        });
        return;
      }

      items.forEach((item, index) => {
        const blockIndex = index + 1;
        if (!isExpanded && blockIndex > mobileInitial) {
          item.setAttribute('data-hidden', 'true');
        } else {
          item.removeAttribute('data-hidden');
        }
      });
    }

    function toggleBrands() {
      isExpanded = !isExpanded;
      updateVisibility();

      toggleBtn.setAttribute('aria-expanded', isExpanded.toString());
      if (toggleText) {
        toggleText.textContent = isExpanded ? 'Show fewer brands' : 'Show more brands';
      }
    }

    toggleBtn.addEventListener('click', toggleBrands);
    window.addEventListener('resize', updateVisibility);

    updateVisibility();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
